import { Button, CircularProgress, Link, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";

import { useNavigate } from "hooks/routerHooks";

import { MeasureImpact, MeasureConf, DrawType } from "types/types";

import DeleteMeasureConfig from "components/measures/addMeasurePage/DeleteMeasureConfig";

interface Props {
  measureConfigs: MeasureConf[];
  measureConfigId: number;
  uuid: string;
  selectedMeasure: MeasureImpact;
  isLoading: boolean;
  isNewMeasureConfig: boolean;
  currentDrawState: DrawType;
  onSaveMeasureConfigs: () => void;
}

export function AddMeasureFooter(props: Props) {
  const {
    uuid,
    measureConfigs,
    measureConfigId,
    selectedMeasure,
    isLoading,
    currentDrawState,
    isNewMeasureConfig,
    onSaveMeasureConfigs,
  } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const foundMeasureConfig = measureConfigs.find(
    (measureConfig) => measureConfig.id === measureConfigId
  );

  function onCancel() {
    queryClient.invalidateQueries(["measureConfigurations", uuid]);
    navigate(`/${uuid}/measures`);
  }

  const isDisabled =
    foundMeasureConfig?.layers.length === 0 ||
    !!foundMeasureConfig === false ||
    currentDrawState === "edit"
      ? true
      : false;

  return (
    <StyledPaper elevation={0}>
      <Link
        onClick={() => {
          onCancel();
        }}
      >
        {t("label.cancel")}
      </Link>
      {!isNewMeasureConfig && (
        <DeleteMeasureConfig measureConfigId={measureConfigId} uuid={uuid} />
      )}
      {selectedMeasure.measure.measurePropertyLinkList.length === 0 && (
        <Button
          variant="green-contained"
          onClick={onSaveMeasureConfigs}
          disabled={isDisabled || isLoading}
        >
          {isLoading && <CircularProgress size={20} />}
          {isLoading && t("label.loading")}
          {!isLoading && t("label.save")}
        </Button>
      )}

      {selectedMeasure.measure.measurePropertyLinkList.length > 0 && (
        <Button
          variant="green-contained"
          type="submit"
          form="measure-form"
          disabled={isDisabled || isLoading}
        >
          {isLoading && <CircularProgress size={20} />}
          {isLoading && t("label.loading")}
          {!isLoading && t("label.save")}
        </Button>
      )}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;

  .MuiButton-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
